
namespace GeniuzPOS.CustomReport {

    @Serenity.Decorators.registerClass()
    export class ReportCusSaleReportDialog extends Serenity.EntityDialog<ReportCusSaleReportRow, any> {
        protected getFormKey() { return ReportCusSaleReportForm.formKey; }
        protected getIdProperty() { return ReportCusSaleReportRow.idProperty; }
        protected getLocalTextPrefix() { return ReportCusSaleReportRow.localTextPrefix; }
        protected getNameProperty() { return ReportCusSaleReportRow.nameProperty; }
        protected getService() { return ReportCusSaleReportService.baseUrl; }
        protected getDeletePermission() { return ReportCusSaleReportRow.deletePermission; }
        protected getInsertPermission() { return ReportCusSaleReportRow.insertPermission; }
        protected getUpdatePermission() { return ReportCusSaleReportRow.updatePermission; }

        protected form = new ReportCusSaleReportForm(this.idPrefix);

    }
}